export default "__VITE_ASSET__Byx9760b__"